module.exports = __webpack_public_path__ + "assets/img/1.a7ca3151.jpg";